
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        localStorage.removeItem('mr_token');
        sessionStorage.removeItem('username');
		sessionStorage.removeItem('clientId');
		// Optionally clear all storage:
        localStorage.clear();
        sessionStorage.clear();
        navigate('/login');
    }, [navigate]);

    return null;
};

export default Logout;
